export default "__VITE_ASSET__CG_BUUMH__"